// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".LoginComponent .FacebookButton{background-color:#3c5b9b !important;padding:12px}.LoginComponent .FacebookButton .facebook-icon{width:24px;height:24px;margin-right:12px}\n", ""]);
// Exports
module.exports = exports;
